import { useField } from 'formik';
import { NftCheckbox, NftCheckboxProps } from '~/components/Nft/Checkbox/NftCheckbox';

export type NftCheckboxFieldProps = NftCheckboxProps;
export const NftCheckboxField = ({
  name = '',
  value,
  children,
  ...props
}: NftCheckboxFieldProps) => {
  const [field] = useField({ type: 'checkbox', name, value });

  return (
    <NftCheckbox {...props} {...field}>
      {children}
    </NftCheckbox>
  );
};
